import { svg } from '@rxdi/lit-html';

export const DiaryIcon = svg`
<svg
 version="1.1"
 id="Capa_1"
 xmlns="http://www.w3.org/2000/svg"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 x="0px"
 y="0px"
 viewBox="0 0 306.094 306.094"
 style="enable-background: new 0 0 306.094 306.094;"
 xml:space="preserve"
>
 <g>
  <g id="Layer_5_27_">
   <g>
    <path
     d="M274.254,131.297h-40.095c-3.3,0-6,2.7-6,6v31.502c0,3.3,2.7,6,6,6h39.72c0,0,4.366,0,4.366-4.373
				c0-9.782,0-26.406,0-35.208C278.245,131.297,274.254,131.297,274.254,131.297z"
    />
    <path
     d="M212.154,109.291c0,0,43.575-0.079,58.101,0c2.695,0.015,7.991,0.088,7.991-7.239c0-24.138,0-87.052,0-87.052
				c0-8.25-6.75-15-15-15H42.848c-8.25,0-15,6.75-15,15v276.094c0,8.25,6.75,15,15,15h220.397c8.25,0,15-6.75,15-15
				c0,0,0-61.026,0-85.287c0-7.5-3.616-9.002-8.742-9.002c-14.337,0-57.35,0-57.35,0c-3.3,0-6-2.7-6-6v-75.514
				C206.154,111.991,208.853,109.291,212.154,109.291z M141.553,144.005c0,4.95-4.05,9-9,9h-50.5c-4.95,0-9-4.05-9-9v-6
				c0-4.95,4.05-9,9-9h50.5c4.95,0,9,4.05,9,9V144.005z M182.053,86.492c0,4.95-4.05,9-9,9h-91c-4.95,0-9-4.05-9-9v-6
				c0-4.95,4.05-9,9-9h91c4.95,0,9,4.05,9,9V86.492z"
    />
   </g>
  </g>
 </g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
 <g></g>
</svg>

`;
